
































































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { MStoreConstants, FeedbackTypeConstants } from '@/types';
import { UserService } from '@/services/UserService';
import SessionStorageService from '@/services/SessionStorageService';
import { DocumentsToStore } from '@/types';
import { NavBarAccessService } from '@/services/NavBarAccessService';
import { NavBarAccessModel } from '@/types';
import { FeedbackHelper, confirmationHelper, AppSettingsHelper } from '@/mixins';
import { LocalStorage } from '@/utils';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import UserNotifications from '@/components/userNotifications/UserNotifications.vue';
import { NavbarItems as CustomerNavbarItems } from '@/customer';

export default Vue.extend({
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  },
  mixins: [FeedbackHelper, confirmationHelper, AppSettingsHelper],
  data() {
    return {
      navBarAccess: {} as NavBarAccessModel,
      featureEnabled: false,
      documentsToStoreRoutes: DocumentsToStore,
      showNotifications: false
    };
  },
  computed: {
    ...mapGetters('oidcStore', ['oidcUser']),
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty', 'isApplicationDirtyOnAnotherTab', 'isApplicationDirtyOnModal']),
    ...mapGetters('workflowJobStore', ['isWorkFlowJobDirty']),
    _isLoading: {
      get(this: any) {
        return this.loading;
      },
      set(this: any, value: boolean) {
        this.$emit('update:loading', value);
      }
    },
    FeedbackType() {
      return FeedbackTypeConstants;
    },
    isDevelopment(this: any) {
      return process?.env?.NODE_ENV === 'development';
    },
    customerNavbarItems(this: any) {
      return this.navBarAccess ? CustomerNavbarItems.filter((x) => x.hasAccess(this.navBarAccess)) : [];
    }
  },
  methods: {
    ...mapActions('oidcStore', ['signOutOidc']),
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async logOut(this: any) {
      try {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, this.isApplicationDirty || this.isWorkFlowJobDirty || this.isApplicationDirtyOnModal);
        if (hasUnsavedChangesToKeep) {
          return;
        }
        if (this.isApplicationDirtyOnAnotherTab) {
          const hasUnsavedChangesToKeepOnOtherTabs: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true, 'You have unsaved changes on an another tab or a window');
          if (hasUnsavedChangesToKeepOnOtherTabs) {
            return;
          }
        }
        LocalStorage.emit(MStoreConstants.LocalStorageKeys.IsApplicationLoggedOutOnAnotherTab, false);
        this.setApplicationDirty(false);
        UserService.disableWindowsAutoLogInForCurrentUserAsync().then(() => {
          SessionStorageService.removeSessionId();
          this.signOutOidc();
        });
      } catch (error) {
        this.$log(error);
      }
    },
    navigate(routeName: string) {
      this.$router.push({ name: routeName });
    },
    async getDataAsync(this: any) {
      this._isLoading = true;
      this.navBarAccess = await NavBarAccessService.getNavBarAccessAsync();
      this._isLoading = false;
      const response = await AxiosConfiguration.axiosWithErrorPage.get('parameter?entityTypeId=0&entityPk=0&group=DocumentsToStore&code=FeatureToggle');
      this.featureEnabled = (response.data as string).toLowerCase();
    },
    onFeedbackClick(this: any, type: string) {
      this.ShowFeedbackInPopup(type);
    }
  },
  async mounted(this: any) {
    await this.getDataAsync();
  },
  components: {
    UserNotifications
  }
});
